/**
 * Materialize file bytes before FormData serialization.
 * Safari (esp. clipboard screenshots) can pass a File with metadata but an empty
 * payload when appended directly to FormData over XHR/Axios.
 */
async function toUploadableFile(fileOrBlob) {
    const arrayBuffer = await fileOrBlob.arrayBuffer();

    if (!arrayBuffer.byteLength) {
        throw new Error("File data is empty and cannot be uploaded.");
    }

    const type = fileOrBlob.type || "application/octet-stream";
    const name = fileOrBlob.name || defaultFileNameForType(type);

    return new File([arrayBuffer], name, {
        type,
        lastModified: Date.now(),
    });
}

function defaultFileNameForType(type) {
    if (type.startsWith("image/")) {
        const extension = type.split("/")[1] || "png";

        return `screenshot.${extension === "jpeg" ? "jpg" : extension}`;
    }

    return "upload.bin";
}

async function uploadFile(fileOrBlob, resource_owner = {}) {
    const safeFile = await toUploadableFile(fileOrBlob);
    const formData = new FormData();
    formData.append("file", safeFile, safeFile.name);

    for (const key in resource_owner) {
        if (resource_owner.hasOwnProperty(key)) {
            // Check if the property is directly on the object and not inherited
            formData.append(key, resource_owner[key]);
        }
    }

    // Do not set Content-Type manually — the browser must add the multipart boundary.
    const options = {
        onUploadProgress: (progressEvent) => {
            console.log("loaded", progressEvent.loaded);
            console.log(
                "progress",
                parseInt(
                    Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total,
                    ),
                ),
            );
        },
    };

    try {
        const { data } = await axios.post("/upload", formData, options);
        return data; //return whole data
    } catch (error) {
        //alert("File upload has failed pleae try again");
        throw error;
    }
}

function dataURItoBlob(dataURI) {
    // convert base64 to raw binary data held in a string
    var byteString = atob(dataURI.split(",")[1]);

    // separate out the mime component
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    // write the bytes of the string to an ArrayBuffer
    var arrayBuffer = new ArrayBuffer(byteString.length);
    var _ia = new Uint8Array(arrayBuffer);
    for (var i = 0; i < byteString.length; i++) {
        _ia[i] = byteString.charCodeAt(i);
    }

    var dataView = new DataView(arrayBuffer);
    var blob = new Blob([dataView], { type: mimeString });
    return blob;
}

export { uploadFile };
